import styled from "styled-components";
import { useState, useContext, MouseEvent } from "react";
import { SpinnerContext } from "../../../Contexts/SpinnerContext";
import { microsoftSignIn } from "../../../Firebase";
import { useNavigate } from "react-router-dom";
import PWABanner from "../PWA-Banner/PWA-Banner";

const LoginWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 300px;

  button {
    background-color: white;
    color: var(--accent-color-dark);
    border: 1px solid var(--accent-color-dark);
    border-radius: 5px;
    padding: 10px 40px;
    font-size: 20px;
    font-weight: 600;
  }
  button:hover {
    background-color: var(--accent-color-dark);
    color: white;
  }

  @media (max-width: 768px) {
    button:hover {
      background-color: initial;
      color: initial;
    }
  }
`;

export default function LoginComponent() {
  const { setIsLoading } = useContext(SpinnerContext);
  const navigate = useNavigate();


  const handleMicrosoftSignIn = async (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    try {
      microsoftSignIn().then((res) => {
        if (typeof res === "object" && res !== null && "uid" in res) {
          navigate("/overview");
        } else {
          console.error("Unexpected response type from oktaSignIn");
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <LoginWrapper>
      <button onClick={handleMicrosoftSignIn}>Log in with Microsoft</button>
      <PWABanner loginPage={true} />
    </LoginWrapper>
  );
}
